import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="spacebar" maskId="round-filled-radius-1-stroke-1.5-IconSpacebar"><path d="M2 18.25V13.75C2 13.3358 2.33579 13 2.75 13C3.16421 13 3.5 13.3358 3.5 13.75V18.25C3.5 18.3881 3.61193 18.5 3.75 18.5H20.25C20.3881 18.5 20.5 18.3881 20.5 18.25V13.75C20.5 13.3358 20.8358 13 21.25 13C21.6642 13 22 13.3358 22 13.75V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacebar;
